<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <div :class="{ 'p-input-icon-right': iconClass }">
      <i :class="iconClass" />
      <InputNumber
        :id="id"
        ref="inputNumber"
        :readonly="readonly"
        :disabled="disabled"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :class="[
          { 'p-invalid': typeof validate !== 'undefined' && validate.$error },
        ]"
        :inputClass="inputClass"
        v-model="inputValue"
        :format="format"
        :showButtons="showButtons"
        :buttonLayout="buttonLayout"
        :incrementButtonClass="incrementButtonClass"
        :decrementButtonClass="decrementButtonClass"
        :incrementButtonIcon="incrementButtonIcon"
        :decrementButtonIcon="decrementButtonIcon"
        :locale="locale"
        :localeMatcher="localeMatcher"
        :mode="mode"
        :prefix="prefix"
        :suffix="suffix"
        :currency="currency"
        :currencyDisplay="currencyDisplay"
        :useGrouping="useGrouping"
        :minFractionDigits="minFractionDigits"
        :maxFractionDigits="maxFractionDigits"
        :min="min"
        :max="max"
        :step="step"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
        @keydown.native="$emit('keydown', $event)"
      />
    </div>
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
      :baseErrorClass="baseErrorClass"
    />
  </div>
</template>

<script>
import InputNumber from "primevue/inputnumber";

export default {
  inheritAttrs: false,
  components: { InputNumber },
  props: {
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    submitted: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: String,
      required: false,
    },
    iconClass: {
      type: String,
      required: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    errorBag: {
      type: Array,
      default: () => [],
    },
    format: {
      required: false,
      type: Boolean,
    },
    showButtons: {
      required: false,
      type: Boolean,
    },
    buttonLayout: {
      required: false,
      type: String,
    },
    incrementButtonClass: {
      required: false,
      type: String,
    },
    decrementButtonClass: {
      required: false,
      type: String,
    },
    incrementButtonIcon: {
      required: false,
      type: String,
    },
    decrementButtonIcon: {
      required: false,
      type: String,
    },
    locale: {
      required: false,
      type: String,
    },
    localeMatcher: {
      required: false,
      type: String,
    },
    mode: {
      required: false,
      type: String,
    },
    prefix: {
      required: false,
      type: String,
    },
    suffix: {
      required: false,
      type: String,
    },
    currency: {
      required: false,
      type: String,
    },
    currencyDisplay: {
      required: false,
      type: String,
    },
    useGrouping: {
      required: false,
      type: Boolean,
    },
    minFractionDigits: {
      required: false,
      type: Number,
    },
    maxFractionDigits: {
      required: false,
      type: Number,
    },
    min: {
      required: false,
      type: Number,
    },
    max: {
      required: false,
      type: Number,
    },
    step: {
      required: false,
      type: Number,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    baseErrorClass: {
      type: String,
      required: false,
    },
  },

  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
